import React from "react";

const STEPS = [
  { id: "leads", label: "Leads" },
  { id: "sequence", label: "Sequence" },
  { id: "senders", label: "LinkedIn Senders" },
  { id: "schedule", label: "Schedule" },
  { id: "preview", label: "Preview" },
];

/**
 * Horizontal 5-step campaign wizard stepper.
 */
export default function Stepper({ currentStep, onStepClick }) {
  const currentIndex = STEPS.findIndex((s) => s.id === currentStep);

  return (
    <div className="flex items-center justify-center gap-2 py-4 px-4 flex-wrap">
      {STEPS.map((step, index) => {
        const isDone = index < currentIndex;
        const isActive = index === currentIndex;
        const canClick = typeof onStepClick === "function" && index <= currentIndex;
        return (
          <React.Fragment key={step.id}>
            {index > 0 && (
              <div
                className={`h-[2px] w-8 sm:w-12 ${
                  isDone || isActive ? "bg-blue-500" : "bg-gray-200"
                }`}
              />
            )}
            <button
              type="button"
              disabled={!canClick}
              onClick={() => canClick && onStepClick(step.id)}
              className={`flex items-center gap-2 ${canClick ? "cursor-pointer" : "cursor-default"}`}
            >
              <span
                className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold border-2 ${
                  isDone
                    ? "bg-blue-500 border-blue-500 text-white"
                    : isActive
                      ? "bg-blue-500 border-blue-500 text-white"
                      : "bg-white border-gray-300 text-gray-400"
                }`}
              >
                {isDone ? "✓" : ""}
                {isActive ? (
                  <span className="w-2.5 h-2.5 rounded-full bg-white" />
                ) : null}
                {!isDone && !isActive ? index + 1 : null}
              </span>
              <span
                className={`text-sm hidden sm:inline ${
                  isActive || isDone ? "text-gray-900 font-medium" : "text-gray-400"
                }`}
              >
                {step.label}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export { STEPS };
